import { Typography } from "@norican/react";
import { useEffect, useState } from "react";

import { logger } from "@/lib/logger";
import { finishTeamsSignIn } from "@/lib/login-popup";

/**
 * Last stop of a sign-in started from the Teams SDK's authentication window:
 * the backend lands here with a hand-off code in the fragment, and this page
 * passes it back to the tab, which closes the window.
 */
export function TeamsAuthEndPage() {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    finishTeamsSignIn().catch((err: unknown) => {
      logger.debug("[auth] could not hand the sign-in back to Teams:", err);
      setFailed(true);
    });
  }, []);

  return (
    <div className="bg-bg flex min-h-screen items-center justify-center px-6">
      <Typography variant="body-sm" tone={failed ? "danger" : "muted"}>
        {failed
          ? "Sign-in finished outside Teams. Close this window and try again."
          : "Signing you in…"}
      </Typography>
    </div>
  );
}
